import React from "react";
import HelperText from "../../components/atoms/HelperText";

const showCanonicalLegend = (transcripts) => {
  // If at least one transcript is canonical, show a color legend
  // Note: only for refseq transcripts
  for (let i = 0; i < transcripts.length; i++) {
    if (transcripts[i].canonical) {
      return (
        <div className="varsome-legend varsome-clearfix">
          <div className="varsome-right">
            <span className="varsome-canonical-box" />{" "}
            <small>- Canonical transcript</small>
            <HelperText fieldDescriptionKey="Canonical transcripts" />
          </div>
        </div>
      );
    }
  }
  return null;
};

export default showCanonicalLegend;
